export default __webpack_public_path__ + "static/media/casaduana_MarioOsorio.20b0f21e.jpg";